import {
  Button,
  DatePicker,
  Dialog,
  Icon,
  NewTable,
  SearchBar,
  SpinningLoader,
  useLanguageSelector,
  useToast,
} from '@vallourec-ui/vallourec-ui'

import { useTranslation } from 'react-i18next'

import React, { useCallback, useEffect, useMemo, useState } from 'react'

import moment from 'moment'

import {
  ButtonContainer,
  ColumnContainer,
  Row,
  SpinningContainer,
  StyledText,
} from './style'

import { template } from './template'
import { DataResultTemplate } from '@/@types/global'
import { documentApproval as documentApprovalPost } from '@/api/post'
import { getActionTranslate } from '@/utils/utils'

const HistoryModal: React.FC<{
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  onOutsideClick: () => void
  doc: any
}> = ({ isOpen, onOutsideClick, doc }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { t } = useTranslation()
  const { toast } = useToast()
  const { currentLanguage } = useLanguageSelector()
  const id = ''
  const [history, setHistorry] = React.useState<any[]>([{ action: '' }])
  const [loading, setLoading] = useState<boolean>(false)
  const [templateColumnResult, setTemplateColumnResult] = React.useState<any[]>(
    []
  )
  const FIELDS_DATE = ['started_on', 'action_on', 'finished_on', 'date_published']

  const handleOutside = () => {
    onOutsideClick()
  }

  useEffect(() => {
    if (isOpen) {
    }
  }, [isOpen])

  useEffect(() => {
    async function fetchData() {
      try {
        if (isOpen) {
          setIsLoading(true)
          setHistorry([])
          if (doc) {
            const result = await documentApprovalPost({ history: doc })
            if (result) {
              const rows = result.items.map((item: any, index: number) => {
                const objectRow = {
                  ...Object.entries(item).reduce((acc, [key, value]) => {
                    if (value != null && value != undefined) {
                      let valueDiv = value
                      if (key === 'action') {
                        valueDiv = getActionTranslate(value, currentLanguage)
                      }
                      if (
                        value &&
                        FIELDS_DATE.some((str) => key.includes(str))
                      ) {
                        valueDiv = moment(value).format(
                          currentLanguage === 'pt-BR'
                            ? `DD/MM/YYYY ${key === 'date_published' ? '' : 'HH:mm'}`
                            : `MM/DD/YYYY ${key === 'date_published' ? '' : 'hh:mm:ss A'}`
                        )
                      }
                      acc[key] = (
                        <div style={{ whiteSpace: 'nowrap' }}>
                          {String(valueDiv)}
                        </div>
                      ) as React.ReactNode
                    }
                    return acc
                  }, {}),
                  index,
                }
                return objectRow
              })

              setHistorry(rows ?? [{ action: ' ' }])
            }
          }
        }
      } catch (error: any) {
        console.log(error)
        throw new Error(error)
      } finally {
        setIsLoading(false)
      }
    }

    const columns = template.map((elem) => {
      return {
        id: elem.id,
        accessorKey: elem.id,
        header: t(elem.header),
        cell: ({ cell }) => {
          return <div>{cell.getValue()}</div>
        },
      } as DataResultTemplate
    })
    setTemplateColumnResult(columns)
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  const renderTable = useCallback(() => {
    return (
      <>
        <NewTable.Root
          key="Table-with-result"
          columnIdWithRowspan="button"
          columns={templateColumnResult ?? []}
          data={history ?? []}
          isBordered
          hasScroll
        />
        <Row
          style={{
            justifyContent: 'flex-end',
            marginTop: '15px',
            marginBottom: '15px',
          }}
        />
      </>
    )
  }, [templateColumnResult, history, t])

  return (
    <Dialog.Root
      isOpen={isOpen}
      setIsOpen={() => setIsOpen(false)}
      closeOnInteractOutside={false}
      width="80%"
      header={
        <Dialog.Header
          title={t<string>('searchReport.history.title')}
        />
      }
      footer={
        <ButtonContainer>
          <Button
            variant="secondary-grey"
            size="sm"
            onClick={() => handleOutside()}
          >
            {t<string>('application.button.close')}
          </Button>
        </ButtonContainer>
      }
    >
      {isLoading ? (
        <SpinningContainer>
          <SpinningLoader />
        </SpinningContainer>
      ) : (
        <ColumnContainer>{renderTable()}</ColumnContainer>
      )}
    </Dialog.Root>
  )
}

export default HistoryModal
